import { Box, Typography, Button } from '@bcp-nextgen-dx-component-factory/design-system';
import { Link } from '@components';
import { rem } from '@helpers';
import { RoundIconWarning } from '@icons';

import { useRequestToCallWarningHelper } from './requestToCallWarning.helper';

export interface RequestToCallWarningProps {
	newRequestContact?: () => void;
	tryAgainButton?: () => void;
}

export const RequestToCallWarning: React.FC<RequestToCallWarningProps> = (props) => {
	const { newRequestContact, tryAgainButton } = props;
	const { resources, onClick } = useRequestToCallWarningHelper();

	return (
		<Box
			styles={{
				flexDirection: 'column',
				minHeight: '100%',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Box>
				<RoundIconWarning />
			</Box>
			<Box styles={{ margin: rem(24, 0, 48, 0), width: rem(790), textAlign: 'center' }}>
				<Typography appearance="headline-200-02">{resources.title}</Typography>
			</Box>
			<Box>
				<Button onPress={tryAgainButton}>{resources.tryAgain}</Button>
			</Box>
			<Box styles={{ margin: rem(24, 0, 48, 0) }}>
				<Button appearance="outline" onPress={newRequestContact}>
					{resources.requestContract}
				</Button>
			</Box>
			<Box>
				<Link onClick={onClick}>
					<Typography colorToken="interaction-01-100">{resources.back}</Typography>
				</Link>
			</Box>
		</Box>
	);
};
